/**
 * Glean — enterprise work search / assistant
 *
 * Declares a single web-accessible-resource, `googleDocs.js`, scoped to
 * `https://docs.google.com/*` with no `use_dynamic_url`. The resource is genuinely
 * unreachable from any other origin, so a negative result elsewhere proves nothing —
 * only docs.google.com can detect it. From that origin the fixed-URL fetch is conclusive.
 *
 * Manifest verified against version 1.2026.526.5000.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cfpdompphcacgpjfbonkdokgjhgabpij';

export const glean: ExtensionDefinition = {
  id: ID,
  name: 'Glean',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  requiredOrigin: 'https://docs.google.com',
  notes:
    'Its one WAR (googleDocs.js) is scoped to docs.google.com, so only that site can ' +
    'detect it — a static resource exposed to a single origin rather than every page.',
  signals: [
    {
      id: 'war-google-docs-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch googleDocs.js — static, but only exposed to docs.google.com.',
      weight: 1,
      run: () => probeFetch(ID, 'googleDocs.js'),
    },
  ],
};
